import { TextSkeleton } from '@/components/Skeleton';

import { CHART_DIMENSIONS } from './constants';
import { LoadingWave } from './LoadingWave';

const { BASE_HEIGHT } = CHART_DIMENSIONS;

interface ChartLoadingSkeletonProps {
  height?: number;
}

export const ChartLoadingSkeletonPrices = () => (
  <div className="flex flex-col gap-3 pb-2 w-full items-start">
    <TextSkeleton width={140} height={35} className="mx-4 mt-3 tablet:mx-6 tablet:mt-5.5" />
    <div className="flex flex-col gap-3 ml-2 tablet:ml-4">
      <TextSkeleton height={18} className="ml-2 w-40 tablet:w-85" />
      <TextSkeleton height={18} className="ml-2 w-40 tablet:hidden" />
    </div>
  </div>
);

export const ChartLoadingSkeleton = ({ height = BASE_HEIGHT }: ChartLoadingSkeletonProps) => {
  return (
    <div className="w-full rounded-2xl h-fit bg-transparent">
      <ChartLoadingSkeletonPrices />
      <div
        className="w-full relative overflow-hidden rounded-b-6 mt-2.5"
        style={{ height: `${height}px`, minHeight: `${BASE_HEIGHT}px` }}
      >
        <div className="absolute top-0 left-0 size-full">
          <LoadingWave />
        </div>
      </div>
      <div className="flex justify-between items-center px-4 pt-3.5 pb-6 tablet:px-6">
        <div className="flex"></div>
        <div className="flex justify-center tablet:justify-end">
          <TextSkeleton width={296} height={28} className="mb-2" />
        </div>
      </div>
    </div>
  );
};
